<template>
    <div class="relative">
        <label ref="cont" class="bg-slate-500/50 block w-full pb-30p relative overflow-hidden group">
            <div v-if="canupload && src" @click.prevent="deleteCursor('cover')"
                 class="absolute right-2 top-2 cursor-pointer bg-red-500 text-white flex items-center justify-center w-5 h-5 rounded-full z-80">
                &times;
            </div>
            <div
                v-if="canupload"
                class="group-hover:z-20 absolute inset-0 cursor-pointer flex bg-slate-500/50 text-white flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="w-10 h-10"
                     viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                          d="M7.646 5.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2z"/>
                    <path
                        d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"/>
                </svg>
            </div>
            <img v-if="src" class="absolute inset-0 w-full h-full overflow-hidden object-cover object-center"
                 :src="src"/>
            <div v-if="loading" aria-hidden="true" class="absolute inset-0 opacity-50 flex items-center justify-center">
                <svg
                    class="w-20 h-20 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                    viewBox="0 0 100 101"
                    fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"/>
                    <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"/>
                </svg>
            </div>
            <input v-if="canupload" @change="readURL('cover', $event)" class="hidden" type="file" accept="image/png, image/jpeg, image/webp, image/gif, image/jpg"/>

            <img v-if="crs" ref="cursor" :src="crs"
                 class="w-20 h-20 -translate-y-1/2 -translate-x-1/2 z-40 absolute hidden" style="left:0; top:0"/>
        </label>

        <label v-if="canupload"
               class="bg-gray-500 cursor-pointer group z-50 absolute w-12 h-12 md:w-20 md:h-20 rounded-full border-2 border-white shadow-xl bottom-1 right-1 md:bottom-5 md:right-5"
               title="Картинка-курсор для вывода над вашей обложкой">
            <div v-if="crs" @click.prevent="deleteCursor('cursor')"
                 class="absolute right-0 top-0 cursor-pointer bg-red-500 text-white flex items-center justify-center w-5 h-5 rounded-full z-80">
                &times;
            </div>
            <img v-if="canupload && crs" :src="crs" class="w-full h-full rounded-full"/>
            <input @change="readURL('cursor', $event)" class="hidden" type="file" accept="image/png, image/jpeg, image/webp, image/gif, image/jpg"/>
            <div
                class="z-70 rounded-full opacity-0 group-hover:opacity-50 absolute inset-0 cursor-pointer flex bg-slate-500/50 text-white items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="w-5 h-5"
                     viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                          d="M7.646 5.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2z"/>
                    <path
                        d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"/>
                </svg>
            </div>
        </label>
    </div>
</template>
<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";

export default {
    props: [
        'url',
        'cursor',
        'canupload',
        'userid'
    ],
    data() {
        return {
            src: this.url || '',
            crs: this.cursor || '',
            loading: false,
        }
    },
    mounted() {
        if (this.cursor) {
            let $cursor = this.$refs.cursor;
            $cursor.classList.remove('hidden');
            let rect = this.$refs.cont.getBoundingClientRect();
            this.$refs.cont.addEventListener("mousemove", (e) => {

                $cursor.style.left = (e.pageX - rect.left) + 'px';
                $cursor.style.top = (e.pageY - rect.top) + 'px';

            }, false);
        }
    },
    methods: {
        deleteCursor(type) {
            Client.delete('/api/v1.1/image/' + type)
                .then(response => {
                    if (type === 'cover') {
                        this.src = null;
                    } else {
                        this.crs = null;
                    }
                });
        },
        readURL(type, event) {
            let input = event.target;
            if (input.files && input.files[0]) {
                let reader = new FileReader();
                reader.onload = (e) => {

                    this.loading = true;

                    Client.post('/api/v1.1/image/' + type, {
                        image: reader.result,
                    }, {
                        headers: {
                            'Content-Type': reader.type
                        }
                    })
                        .then(response => {
                            this.loading = false;

                            if (type === 'cover') {
                                this.src = e.target.result;
                            } else {
                                this.crs = e.target.result;
                            }

                            notify({
                                type: 'success',
                                text: 'Загружено',
                            });
                        })
                        .catch(error => {
                            this.loading = false;
                            notify({
                                type: 'error',
                                text: error.response.data.message || 'Ошибка загрузки',
                            });
                        });
                }
                reader.readAsDataURL(input.files[0]);
            }
        }
    },
}
</script>
